import { UIRouterModule } from "@uirouter/angular";
import { NgModule } from "@angular/core";
import { UiDrawerModule } from "@webapp/ui/drawer/drawer.module";
import { AbstractDrawerViewContainerComponent } from "./utils/drawer.routing.utils";

@NgModule({
  imports: [UIRouterModule, UiDrawerModule],
  declarations: [AbstractDrawerViewContainerComponent],
})
export class CoreRoutingModule {}
